import {sendListenerEvent } from '@/utils'
import { $config } from '@/global/index'
import store from '@/store'
import { deployEnv } from '@/config/deployEnv'
import {IMessage, IEnterOrExitUavSimulateModule, ISwitchOpenGuid} from './interface'
import { SystemMode } from '@/types/system'
const EngineApi = $config.ENGINE_API
const EngineName = $config.ENGINE_NAME;



/**
 * 创建消息
 * @param {string} type     消息类型
 * @param {any} data        消息传参内容
 * @returns {Object}        消息对象
 */
const createMessage = (type:string, data:any):IMessage =>({type, data,engineName:EngineName,})

//进入或退出无人机模拟
export const enterOrExitUavSimulateModule = (data:any):void =>{
    data.version = 1.21;
    data.phoneNum = store.state.persistence.userInfo.phoneNum;
    data.env = deployEnv;
    if(store.state.viewData.systemMode === SystemMode.ONLINE_TRAINING){
        //无人机巡视，而非技能考评模式
        data.enableCloudStorage = store.state.persistence.enableCloudStorage
    }
    sendListenerEvent(EngineApi, createMessage('enterOrExitUavSimulateModule', data))
}

//更改引导状态
export const switchOpenGuid = (data:ISwitchOpenGuid):void => {
    sendListenerEvent(EngineApi, createMessage('switchOpenGuid', data))
}

//切换视野
export const switchView = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('switchView', data))
}

//重置
/**
 *
 * @param data {
 *      windSpeedRange: string, //风速范围 "0,0.2"
 *      windDirectionIndex: number | string,//风向下标
 *      forbidSaveResult: number | string, //用于通关测试，当为通关测试困难关卡的前两个任务时，传1，其他时候传0或不传
 * }
 */
export const resetView = (data?:any)=>{
    sendListenerEvent(EngineApi, createMessage('reset', data))
}

export const switchUnlockUav = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('switchUnlockUav', data))
}

//一键返航,无需传参
export const oneKeyReturn = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('oneKeyReturn', data))
}

/**
 * 切换拍摄模式
 * @param {Object} data
 * data:{
 *  shootingMode:''//0为拍照，1为录像
 * }
 */
export const switchShootingMode = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('switchShootingMode', data))
}

//拍照/开始摄像/结束摄像,无需传参
export const shoot = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('shoot', data))
}

/**
 * 设置zoom值
 * @param {Object} data
 * data:{
 *  zoom:'',//变焦值
 * }
 */
export const setZoom = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('setZoom', data))
}

//三维强行获取焦点
export const forceGainFocus = (data = {}):void =>{
    sendListenerEvent(EngineApi, createMessage('forceGainFocus', data))
}

export const stopReturn = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('stopReturn', data))
}

export const refreshUserConfig = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('refreshUserConfig', data))
}

//切换无人机模式
export const switchFlyMode = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('switchFlyMode', data))
}


//暂停或者回复三维
export const setPause = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('setPause', data))
}

/**
 *
 * @param data {
 *      message: string | null, // 消息内容
 *      messageType: string, // 消息类型   info | error
 *      alarmCode?: string, // 告警码 偏差消息的code（可选）
 * }
 */
export const recordProcessMessage = (data:{message:string | null, messageType:string, messageDuration?:number | string, alarmCode?: string | null | undefined })=>{
    sendListenerEvent(EngineApi, createMessage('recordProcessMessage', data))
}


//播放/暂停和调整速度
export const updateReplayData = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('updateReplayData', data))
}

export const locateToTimePoint = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('locateToTimePoint', data))
}

//杆塔认识--设备预览页面--进入或退出
/**
 *
 * @param data
 * data = {
 *  enter: number  //1/true为进入，0/false为退出
 *  modelName: string
 *  airlinePointList: array
 *  devicePartList: array
 * }
 */
export const enterOrExitDeviceStudyModule = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('enterOrExitDeviceStudyModule', data))
}

//杆塔认识--设备预览页面--重置
export const resetDeviceStudyView = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('resetDeviceStudyView', data))
}

//杆塔认识--设备预览页面--切换部件和点位模式切换--1为部件模式，2为点位模式 0关闭切换
/**
 *
 * @param data
 * data = {
 *  mode: number  //1为部件模式，2为点位模式 0关闭切换
 * }
 */
export const switchDeviceStudyMode = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('switchDeviceStudyMode', data))
}

//杆塔认识--设备预览页面--选择部件或者点位 id	number / string	是	设备模式（mode: 1）下为 id ；点位模式（mode: 2）下为 pointId
/**
 *
 * @param data
 * data = {
 *  id: number / string
 * }
 * 设备模式（mode: 1）下为 id ；点位模式（mode: 2）下为 pointId  , 取消选中时 data = {}
 */
export const selectModel = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('selectModel', data))
}

//杆塔认识--设备预览页面--分解设备
/**
 *
 * @param data
 * data = {
 *  modelName: string
 * }
 */
export const disassembleModel = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('disassembleModel', data))
}

//杆塔认识--设备预览页面--恢复设备
/**
 *
 * @param data
 * data = {
 *  modelName: string     //拆解时传入的父节点 modelName。须已存在对应 ModelExplodeControl
 * }
 */
export const restoreModel = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('restoreModel', data))
}

//杆塔认识--设备预览页面-- 显示或隐藏航线
/**
 *
 * @param data
 * data = {
 *  show: boolean   //true为显示，false为隐藏
 * }
 */
export const showOrHideAirLine = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('showOrHideAirLine', data))
}

/**
 * 更新电池状态
 * @param data
 * data = {
 *  status: number   //电池状态   1为自动返航(电量到达12%时)，2为电量耗尽(电量到达0%时)
 * }
 */
export const updateBatteryStatus = (data = {})=>{
    sendListenerEvent(EngineApi, createMessage('updateBatteryStatus', data))
}








